import { usePublicSettings } from '@/react/portainer/settings/queries';

import { Alert } from '@@/Alert';

interface Props {
  registryName?: string;
  docsUrl?: string;
}

export function FipsWarning({ registryName, docsUrl }: Props) {
  const isFipsEnabledQuery = usePublicSettings({
    select: (settings) => settings.FIPSMode,
  });

  const isFipsEnabled = isFipsEnabledQuery.data;

  if (!isFipsEnabled) {
    return null;
  }

  return (
    <Alert color="warn">
      When running in FIPS mode, you are responsible for ensuring your registry
      endpoint is FIPS-compliant.
      {docsUrl ? (
        <>
          {' '}
          <a
            href={docsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            Consult {registryName} documentation
          </a>{' '}
          for FIPS compliance information.
        </>
      ) : (
        <>
          {' '}
          Consult your registry&apos;s documentation for FIPS compliance
          information.
        </>
      )}
    </Alert>
  );
}
